import { call, put } from 'redux-saga/effects';
import * as api from 'reduxStore/apiService';
import { requestInitStripeSuccess, RequestInitStripeAction } from './actions';

interface StripeSetupResponse {
  stripePublicApiKey: string;
}

export function* postSetupStripe(params: RequestInitStripeAction) {
  const { supplierId } = params.payload;
  const url = `/api/supplier/${supplierId}/payment/initialise-stripe-checkout`;
  try {
    const data: StripeSetupResponse = yield call(api.post, url);
    const result = {
      stripePublicApiKey: data.stripePublicApiKey,
    };
    yield put(requestInitStripeSuccess(result));
  } catch (err) {
    console.log(err);
  }
}
